module.exports = __webpack_public_path__ + "img/Kjærlighet_Bilde-av-boken.6fcc99a1.jpg";